import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `RowDirective` represent a row of the React Spreadsheet.
 * It must be contained in a `SheetDirective`.
 * ```tsx
 * <SpreadsheetComponent>
 *   <SheetsDirective>
 *    <SheetDirective>
 *    <RowsDirective>
 *    <RowDirective></RowDirective>
 *    </RowsDirective>
 *    </SheetDirective>
 *   </SheetsDirective>
 * </SpreadsheetComponent>
 * ```
 */
export class RowDirective extends ComplexBase {
}
RowDirective.moduleName = 'row';
export class RowsDirective extends ComplexBase {
}
RowsDirective.propertyName = 'rows';
RowsDirective.moduleName = 'rows';
